import FormHandler from "./ahx-wcpl-ajax-form.js";

export class DeleteItemHandler extends FormHandler {
    constructor(formElement) {
        super(formElement);

        this.listTable = document.getElementById("product_list_items");

        this.modalDiv?.addEventListener("show.bs.modal", (event) => {
            let row = event.relatedTarget.closest(".row");
            if (row) {
                this.itemId = row.dataset.id;

                let itemIdElement =
                    this.formElement.querySelector("[name='item_id'");
                itemIdElement.value = this.itemId;

                //this.rowId = row.rowIndex;
                this.row = row;
            }
        });
    }

    async submitForm(event) {
        try {
            //this.hideModal();
            //this.row.classList.add("show-overlay");
            //this.row.insertAdjacentHTML("beforeend", this.spinner);

            let response = await super.submitForm(event);
        } catch (error) {
            console.log(error);
        } finally {
            this.row.remove();
        }
    }
}

export class AddAllListItemsToCart extends FormHandler {
    constructor(formElement) {

        super(formElement);

        this.listTable = document.getElementById("product_list_items");
        this.updateData();
        this.bindEvents();

    }

    bindEvents() {

        document.addEventListener("decreaseCount", (event) => {
            var source = event.detail.input;
            if ( this.listTable && this.listTable.contains(source) ) {
                this.updateData();
            }
        });
        document.addEventListener("increaseCount", (event) => {
            var source = event.detail.input;
            if ( this.listTable && this.listTable.contains(source) ) {
                this.updateData();
            }
        });
        document.addEventListener("searchFilterRows", (event) => {
            var source = event.detail.table;
            if ( this.listTable && this.listTable == source ) {
                this.updateData();
            }
        });

    }


    updateData() {

        if ( this.listTable ) {

            var item_rows = this.listTable.querySelectorAll("#product_list_items .row");
            if ( item_rows.length > 0 ) {
    
                var item_data = [];
    
                item_rows.forEach((row) => {
                    var style = window.getComputedStyle( row, null );
                    if ( style.display !== 'none' ) {
                        var product_id = row.dataset.productId;
                        var qty = row.querySelector("[name='quantity']").value;
                        if ( qty > 0 ) {
                            item_data.push({
                                product_id: product_id,
                                qty: qty
                            });
                        }
                    }
                });
    
                document.getElementById("add_all_list_items_count").textContent = item_data.length;
    
                const form = this.formElement;
                form.dataset.items = JSON.stringify(item_data);
    
    
            }

        }


    }

    async submitForm(event) {
        try {

            event.preventDefault();
            this.showFullPageSpinner();

            if ( confirm( 'Are you sure you want to add all of the selected items to your cart?' ) ) {

                var item_rows = this.listTable.querySelectorAll("#product_list_items .row");
                if ( item_rows.length > 0 ) {
    
                    var item_data = [];
    
                    item_rows.forEach((row) => {
                        var style = window.getComputedStyle( row, null );
                        if ( style.display !== 'none' ) {
                            var product_id = row.dataset.productId;
                            var qty = row.querySelector("[name='quantity']").value;
                            if ( qty > 0 ) {
                                item_data.push({
                                    product_id: product_id,
                                    qty: qty
                                });
                            }
                        }

                    });
    
                    if (item_data.length > 0) {
    
                        const form = this.formElement;
                        var item_data_field = form.querySelector("[name='items']");
                        item_data_field.value = JSON.stringify(item_data);
                        const data = await super.submitForm(event);
                        this.refreshCartFragments(data);
                        this.showMiniCart();
    
                    }
    
                }




            }

        } catch (error) {
            console.log(error);
        } finally {
            this.hideFullPageSpinner();
        }
    }
}

export class AddAllOrderItemsToCartHandler extends FormHandler {
    constructor(formElement) {
        super(formElement);

        this.listTable = document.getElementById("product_list_items");
    }

    async submitForm(event) {
        try {
            this.showFullPageSpinner();

            const data = await super.submitForm(event);

            this.refreshCartFragments(data);
            
        } catch (error) {
            console.log(error);
        } finally {
            this.showMiniCart();
            this.hideFullPageSpinner();
        }
    }
}

export class AddListItemToCart extends FormHandler {
    constructor(formElement) {
        super(formElement);

        this.listTable = document.getElementById("product_list_items");
    }

    async submitForm(event) {
        const row = event.target.closest(".row");

        try {
            const qty = row.querySelector("[name='quantity']").value;
            const productId = row.dataset.productId;

            let actionField = document.createElement("input");
            actionField.setAttribute("type", "hidden");
            actionField.setAttribute("name", "action");
            actionField.setAttribute("value", "ahx_wcpl_add_list_item_to_cart");

            let productIdField = document.createElement("input");
            productIdField.setAttribute("type", "hidden");
            productIdField.setAttribute("name", "product_id");
            productIdField.setAttribute("value", productId);

            let qtyField = document.createElement("input");
            qtyField.setAttribute("type", "hidden");
            qtyField.setAttribute("name", "quantity");
            qtyField.setAttribute("value", qty);

            //event.target.appendChild(actionField);
            //event.target.appendChild(itemIdField);
            //event.target.appendChild(itemIdField);
            this.formElement.appendChild(actionField);
            this.formElement.appendChild(productIdField);
            this.formElement.appendChild(qtyField);

            // Show spinner
            //row.classList.add("show-overlay");
            row.insertAdjacentHTML("beforeend", this.getSpinnerHtml());

            let data = await super.submitForm(event);

            this.refreshCartFragments(data);
            this.showMiniCart();
        } catch (error) {
            console.log(error);
        } finally {
            //row.classList.remove("show-overlay");
            row.querySelector('.add-item-spinner').remove();
        }
    }
}
